/** Minimal full-viewport / inset loading shell (no card chrome). */
export function DataLoadingFallback({
  label,
  inset = false,
  testId,
}: {
  label?: string;
  inset?: boolean;
  testId?: string;
}) {
  const className = inset ? 'data-loading data-loading--inset' : 'data-loading';
  return (
    <div className={className} role="status" aria-live="polite" data-testid={testId}>
      <div className="data-loading__spinner" aria-hidden="true" />
      {label ? <p className="data-loading__label">{label}</p> : null}
    </div>
  );
}
